import { createClient } from './client';
import netowrkClient from './network-client';

export default createClient(netowrkClient);
